import {type IdentityResponse, type AuthenticationContext} from '../api';
import {MOVISTAR_ES, O2_ES, O2_UK, VIVO_BR, type Brand, O2_DE, BLAU_DE} from './brands';

type LoginHintMatcher = (identities: IdentityResponse[], loginHint: string) => IdentityResponse | null;

const movesLoginHintMatcher: LoginHintMatcher = (identities: IdentityResponse[], loginHint: string) => {
    const [prefix, identifier] = loginHint.split(':');

    const requiredType = {
        msisdn: 'phone_number',
        username: 'uid',
        nif: 'uid',
        uid: 'uid',
        email: 'email',
    }[prefix.toLowerCase()];

    if (!requiredType) {
        return null;
    }

    const matchesAuthContext = (authenticationContext: AuthenticationContext) => {
        if (authenticationContext.type !== requiredType) {
            return false;
        }
        if (requiredType === 'phone_number') {
            return authenticationContext.identifier.replace('+', '') === identifier;
        }
        return authenticationContext.identifier === identifier;
    };

    for (const identity of identities) {
        if (identity.authentication_context.some(matchesAuthContext)) {
            return identity;
        }
    }

    return null;
};

const nullLoginHintMatcher: LoginHintMatcher = () => null;

const LOGIN_HINT_MATCHER_BY_BRAND: {[brand in Brand]: LoginHintMatcher} = {
    [MOVISTAR_ES]: movesLoginHintMatcher,
    [O2_UK]: nullLoginHintMatcher,
    [O2_ES]: nullLoginHintMatcher,
    [VIVO_BR]: nullLoginHintMatcher,
    [O2_DE]: nullLoginHintMatcher,
    [BLAU_DE]: nullLoginHintMatcher,
};

export const findMatchingIdentityForLoginHint = (
    identities: IdentityResponse[],
    loginHint: string,
    brand: Brand
): IdentityResponse | null => {
    const matcher = LOGIN_HINT_MATCHER_BY_BRAND[brand];
    return matcher(identities, loginHint);
};
